import { $ } from "../../helpers/dom-selectors.js";
export default class PasswordChecker {
    _input;
    _submitBtn;
    constructor(input, submitBtn) {
        this._input = input;
        this._submitBtn = submitBtn;
        this._init();
    }
    _init() {
        this._input.addEventListener('input', (e) => {
            this._onInput(e);
        });
    }
    _onInput(e) {
        const target = e.currentTarget;
        const isLongEnough = this._handlePassCriteria('char', target.value.length);
        const hasNumber = this._handlePassCriteria('num', target.value);
        const hasUpper = this._handlePassCriteria('upper', target.value);
        const hasLower = this._handlePassCriteria('lower', target.value);
        if (isLongEnough && hasNumber && hasUpper && hasLower) {
            this._submitBtn.disabled = false;
            this._submitBtn.classList.remove('reset-pass');
        }
        else {
            this._submitBtn.disabled = true;
            this._submitBtn.classList.add('reset-pass');
        }
    }
    _handlePassCriteria(criteria, val) {
        let res = false;
        switch (criteria) {
            case 'char':
                if (val >= 8) {
                    this._showCriteriaResult(criteria, true);
                    res = true;
                }
                else {
                    this._showCriteriaResult(criteria, false);
                    res = false;
                }
                break;
            case 'num':
                const hasNumber = /\d/;
                if (hasNumber.test(val.toString())) {
                    this._showCriteriaResult(criteria, true);
                    res = true;
                }
                else {
                    this._showCriteriaResult(criteria, false);
                    res = false;
                }
                break;
            case 'upper':
                const hasUpper = /[A-Z]/;
                if (hasUpper.test(val.toString())) {
                    this._showCriteriaResult(criteria, true);
                    res = true;
                }
                else {
                    this._showCriteriaResult(criteria, false);
                    res = false;
                }
                break;
            case 'lower':
                const hasLower = /[a-z]/;
                if (hasLower.test(val.toString())) {
                    this._showCriteriaResult(criteria, true);
                    res = true;
                }
                else {
                    this._showCriteriaResult(criteria, false);
                    res = false;
                }
        }
        return res;
    }
    _showCriteriaResult(criteria, isValid) {
        const passCriterias = $(document, '.pass-criteria');
        const currentReq = passCriterias.find(node => node.getAttribute('data-req') === criteria);
        const spans = $(currentReq, 'span');
        if (isValid) {
            spans.forEach(span => span.classList.add('pass-criteria-success'));
            spans[0].innerHTML = '✔&#xfe0e;';
        }
        else {
            spans.forEach(span => span.classList.remove('pass-criteria-success'));
            spans[0].innerHTML = '✘';
        }
    }
}
